import React from "react";
import W from "../../assets/WaterP.png";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { ServiceTag } from "../ui/ServiceTag";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";

const WaterPumpReplacement = () => {
  return (
    <>
      <SeoHead
        title="Water Pump Replacement in Temecula | Advanced Automotive Smog"
        description="Water pump replacement in Temecula to keep coolant flowing and protect your engine from the overheating that follows a failed pump."
        path="/services/water-pump"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Water pump replacement"
          path="/services/water-pump"
          description="Water pump replacement in Temecula to keep coolant flowing and protect your engine from the overheating that follows a failed pump."
          serviceType="Water pump replacement"
        />
      <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">
        <div className="order-1 flex w-full justify-center md:order-none md:w-1/2">
          <div className="relative w-full max-w-xs sm:max-w-sm">
            <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
            <img
              src={W}
              alt="Water pump replacement service"
              className="relative h-auto w-full rounded-3xl border border-slate-200 object-cover shadow-xl transition duration-500 ease-brand md:hover:scale-[1.02]"
            />
          </div>
        </div>

        <div className="w-full md:w-1/2">
          <ServiceTag>Cooling system</ServiceTag>

          <h1 className="mb-3 text-2xl font-semibold tracking-tight text-navy-900 sm:text-3xl md:text-4xl">
            Water pump replacement
          </h1>

          <p className="mb-6 text-sm leading-relaxed text-slate-700 sm:text-base">
            Keep your engine cool with a high-quality water pump replacement. We provide fast,
            efficient service so your vehicle stays at safe operating temperatures.
          </p>

          <h2 className="mb-2 text-lg font-semibold text-teal-600 sm:text-xl">
            What is water pump replacement?
          </h2>

          <p className="mb-5 text-sm leading-relaxed text-slate-700 sm:text-base">
            The water pump circulates coolant through the engine to prevent overheating. If it
            fails, it can lead to serious engine damage. Replacing it on time protects your
            investment.
            <br />
            <br />
            Our service includes diagnosis, removal of the worn pump, and installation of a
            durable replacement so coolant flows reliably again.
          </p>

          <ul className="space-y-2.5 text-sm text-slate-700 sm:text-base">
            <li className="flex items-start gap-2">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-teal-600" />
              <span>Fast inspection and professional replacement</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-teal-600" />
              <span>Quality components for daily drivers and premium vehicles</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-teal-600" />
              <span>Helps prevent overheating and costly engine repairs</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-teal-600" />
              <span>Clear communication and honest recommendations</span>
            </li>
          </ul>

          <div className="mt-8 flex justify-center md:justify-start">
            <PrimaryLink to="/contact" className="px-10 py-3 text-base">
              Book appointment
            </PrimaryLink>
          </div>
        </div>
      </div>
            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default WaterPumpReplacement;
